<template>
	<label
		:for="id"
		:class="labelClass"
	>
		<div class="relative flex items-center shrink-0">
			<input
				:id="id"
				v-model="checkedValue"
				type="radio"
				:value="option.value"
				:tabindex="tabindex"
				class="transition-all duration-100 bg-mx-gray-200 dark:border-2 border-mx-gray-500 appearance-none h-4 w-4 rounded-full cursor-pointer group-has-[:checked]:bg-mx-orange group-has-[:checked]:border-mx-orange text-mx-orange ring-mx-orange focus:ring-mx-orange hover:bg-mx-gray-300 dark:hover:bg-mx-gray-500/20 dark:bg-mx-green-900 group-has-[:checked]:dark:bg-mx-orange"
			>
			<div class="absolute left-[5px] top-[5px] w-1.5 h-1.5 bg-transparent group-has-[:checked]:bg-white dark:group-has-[:checked]:bg-mx-green-900 rounded-full transform transition-transform duration-100" />
		</div>
		<div class="flex flex-col">
			<span>
				{{ option.label }}
			</span>
			<span
				v-if="help"
				class="text-sm text-mx-gray-500 dark:text-mx-gray-400 mt-1"
			>
				{{ help }}
			</span>
		</div>
	</label>
</template>

<script setup lang="ts">
const props = defineProps({
	option: {
		type: Object as PropType<{
			id: string | number
			value: string | number | boolean
			label: string
		}>,
		required: true
	},
	help: {
		type: String,
		default: ''
	},
	tabindex: {
		type: Number,
		default: 0
	},
	labelClass: {
		type: [ String, Array ],
		default: 'relative flex items-center w-full px-2 space-x-2 cursor-pointer group dark:text-mx-gray-300'
	}
})

const { option } = toRefs(props)

const checkedValue = defineModel<string | number | boolean>({ default: '' })

const id = computed(() => option.value?.id?.toString())
</script>
